import { OrganizationsService, UserService } from '@shared/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInitAction } from '../actions/app-actions';
import { Actions, Effect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { EMPTY, of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ScopeEffects {
	@Effect({ dispatch: true })
	init$ = this.actions$.pipe(
		ofType(ROOT_EFFECTS_INIT),
		map(() => {
			let scope = localStorage.getItem('selectedOrganization');
			if (scope) {
				return { type: 'INIT_SCOPE', payload: { isScope: true, scope, hostname: document.location.hostname } };
			}

			const domain = document.location.hostname.split('.').splice(1).join('.');

			const hostname = document.location.hostname.toLowerCase();
			const hostParts = hostname.split('.');
			scope = hostParts[0].toUpperCase();
			const isNgrok = hostParts[1].indexOf('ngrok') !== -1;

			let isScope = false;

			if (isNgrok) {
				isScope =
					scope === 'ABONNEMENT' ||
					scope === 'SAAQ' ||
					scope === 'ULAVAL' ||
					scope === 'CEM' ||
					scope === 'UQAM' ||
					scope === 'RAMQ' ||
					scope === 'ARTM' ||
					scope === 'CISSSBSL' ||
					scope === 'CISSSLAN' ||
					scope === 'CISSSLAU' ||
					scope === 'CISSSCA' ||
					scope === 'CISSSO' ||
					scope === 'CUSM' ||
					scope === 'CISSSGASPESIe' ||
					scope === 'CCSMTL' ||
					scope === 'CIUSSSEMTL' ||
					scope === 'CISSSCA' ||
					scope === 'CIUSSSE-CHUS' ||
					scope === 'CIUSSS-SLSJ' ||
					scope === 'COMTL' ||
					scope === 'CNMTL' ||
					scope === 'CISSSMO' ||
					scope === 'INRS' ||
					scope === 'CSSDM' ||
					scope === 'CSSC' ||
					scope === 'VILLEQUEBEC' ||
					scope === 'TESTENDTOEND' ||
					scope === 'CISSSME' ||
					scope === 'CNESST';
			} else {
				isScope =
					hostname === 'abonnement.spaq.com' ||
					hostname === 'saaq.spaq.com' ||
					hostname === 'ulaval.spaq.com' ||
					hostname === 'cem.spaq.com' ||
					hostname === 'uqam.spaq.com' ||
					hostname === 'ramq.spaq.com' ||
					hostname === 'artm.spaq.com' ||
					hostname === 'cisssbsl.spaq.com' ||
					hostname === 'cisssca.spaq.com' ||
					hostname === 'cissso.spaq.com' ||
					hostname === 'cusm.spaq.com' ||
					hostname === 'cissslan.spaq.com' ||
					hostname === 'cissslau.spaq.com' ||
					hostname === 'saaq.passerelle.production.spaq.app' ||
					hostname === 'cisssgaspesie.spaq.com' ||
					hostname === 'ccsmtl.spaq.com' ||
					hostname === 'ciusssemtl.spaq.com' ||
					hostname === 'cisssca.spaq.com' ||
					hostname === 'ciussse-chus.spaq.com' ||
					hostname === 'ciusss-slsj.spaq.com' ||
					hostname === 'comtl.spaq.com' ||
					hostname === 'cnmtl.spaq.com' ||
					hostname === 'cisssmo.spaq.com' ||
					hostname === 'inrs.spaq.com' ||
					hostname === 'cssdm.spaq.com' ||
					hostname === 'cssc.spaq.com' ||
					hostname === 'cnesst.spaq.com' ||
					hostname === 'villequebec.spaq.com' ||
					hostname === 'staging.spaq.app' ||
					domain === 'passerelle.staging.spaq.app' ||
					domain === 'dev.spaq.app';
			}

			// Force initial hosts to become CIUSSSE
			if (scope === 'STAGING' || scope === 'ABONNEMENT') {
				scope = 'CIUSSSE';
				isScope = true;
			}
			if (scope === 'PUBLIC') {
				scope = 'PUBLIC';
				isScope = true;
			}

			if (scope === 'CIUSSSEMTL') {
				scope = 'CIUSSSEMTL';
				isScope = true;
			}
			if (scope === 'ULAVAL') {
				scope = 'ULAVAL';
				isScope = true;
			}
			if (scope === 'CIUSSSE-CHUS') {
				scope = 'CIUSSSE-CHUS';
				isScope = true;
			}
			if (scope === 'CCSMTL') {
				scope = 'CCSMTL';
				isScope = true;
			}
			if (scope === 'CEM') {
				scope = 'CEM';
				isScope = true;
			}
			if (scope === 'COMTL') {
				scope = 'COMTL';
				isScope = true;
			}
			if (scope === 'CNMTL') {
				scope = 'CNMTL';
				isScope = true;
			}
			if (scope === 'CNESST') {
				scope = 'CNESST';
				isScope = true;
			}
			if (scope === 'CISSSGASPESIE') {
				scope = 'CISSSGASPESIE';
				isScope = true;
			}
			if (scope === 'CISSSMO') {
				scope = 'CISSSMO';
				isScope = true;
			}
			if (scope === 'CISSSMC') {
				scope = 'CISSSMC';
				isScope = true;
			}
			if (scope === 'CISSSCA') {
				scope = 'CISSSCA';
				isScope = true;
			}
			if (scope === 'CSSDM') {
				scope = 'CSSDM';
				isScope = true;
			}
			if (scope === 'CNESST') {
				scope = 'CNESST';
				isScope = true;
			}
			if (scope === 'VILLEQUEBEC') {
				scope = 'VILLEQUEBEC';
				isScope = true;
			}
			if (scope === 'TESTENDTOEND') {
				scope = 'TESTENDTOEND';
				isScope = true;
			}

			if (scope === 'CISSSME') {
				scope = 'CISSSME';
				isScope = true;
			}

			if (scope === 'SANTEQUEBECME') {
				scope = 'CISSSME';
				isScope = true;
			}

			if (
				scope &&
				(scope === 'LOCALHOST' || scope === 'DEV' || scope === 'PROD' || scope === 'LOCAL' || scope.substr(0, 4) === 'TASK')
			) {
				scope = 'PUBLIC';
				isScope = true;
			}
			return { type: isScope ? 'INIT_SCOPE' : 'SKIP_SCOPE', payload: { isScope, scope, hostname: document.location.hostname } };
		})
	);
	@Effect({ dispatch: true })
	initScope$ = this.actions$.pipe(
		ofType('INIT_SCOPE'),
		switchMap((action: any) => {
			if (['localhost', 'dev.spaq.web', 'prod.spaq.dev', 'local.spaq.dev'].includes(document.location.hostname)) {
				return of({ type: 'INIT_SCOPE_SUCCESS', payload: { ...action.payload, config: { enableGateway: true } } });
			}
			return this.organizationService.getOrganizationConfig(action.payload.scope).pipe(
				map(result => {
					if (result === null || typeof result !== 'object') {
						return { type: 'INIT_SCOPE_FAILED', payload: { code: 'not_found' } };
					}
					if (result.enableGateway !== true) {
						return { type: 'INIT_SCOPE_FAILED', payload: { code: 'not_allowed' } };
					}
					return { type: 'INIT_SCOPE_SUCCESS', payload: { ...action.payload, config: result } };
				}),
				catchError(e => of({ type: 'INIT_SCOPE_FAILED', code: 'not_found', message: JSON.stringify(e) }))
			);
		})
	);
	@Effect({ dispatch: false })
	initScopeFailed$ = this.actions$.pipe(
		ofType('INIT_SCOPE_FAILED'),
		exhaustMap((action: any) => {
			if (!action.payload || !action.payload.code) {
				return EMPTY;
			}
			if (action.payload.code === 'not_found') {
				return this.router.navigate(['/auth/error/not_found']);
			}
			if (action.payload.code === 'not_allowed') {
				return this.router.navigate(['/auth/error/not_allowed']);
			}
			return EMPTY;
		})
	);
	@Effect({ dispatch: true })
	initScopeSuccess$ = this.actions$.pipe(
		ofType('INIT_SCOPE_SUCCESS', 'SKIP_SCOPE'),
		map((action: any) => new AppInitAction(action.payload, new Date().getTime()))
	);

	constructor(
		private actions$: Actions,
		private dialogService: DialogService,
		private user: UserService,
		private router: Router,
		private store: Store<any>,
		private organizationService: OrganizationsService
	) {}
}
